import { render, staticRenderFns } from "./EmployerUpload.vue?vue&type=template&id=b2c36bd2&"
import script from "./EmployerUpload.vue?vue&type=script&lang=js&"
export * from "./EmployerUpload.vue?vue&type=script&lang=js&"
import style0 from "./EmployerUpload.vue?vue&type=style&index=0&id=b2c36bd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports